import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { ability } from '@/common/ability'
import BodyClass from 'vue-body-class'
import { i18n } from '@/plugins/i18n'
import Helpers from '@/plugins/helpers'
import elements from './components/elements'
import { ApiServiceInit , ShopApiServiceInit } from '@/common/api.service'
import { abilitiesPlugin } from '@casl/vue'
import VueClipboard from 'vue-clipboard2'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import CountryFlag from 'vue-country-flag'
import vSelect from 'vue-select'
import mixins from '@/plugins/mixin'
import initMobileTables from '@/common/mobile-tables'


Vue.component('country-flag', CountryFlag)

// import styles
import './assets/vendors/global/vendors.bundle.rtl.css'
import './assets/css/style.css'
import './assets/new/bootstrap.css'
import './assets/new/style.css'
import 'vue-select/dist/vue-select.css'

// import vendors
import 'jquery-validation'
import 'bootstrap'
import 'bootstrap-select'


// Load plugins
Vue.use(BodyClass, router)
Vue.use(abilitiesPlugin, ability)
Vue.use(VueClipboard)
Vue.use(Helpers)
Vue.use(mixins);
// Vue.use( CKEditor );

import '@/plugins/layout'
import '@/plugins/vendors'
import '@/plugins/init-app'


// Vue Select
Vue.component('v-select', vSelect)


// Persian date picker
Vue.component('datePicker', VuePersianDatetimePicker)
// Vue.component('ckeditor', CKEditor)

// load components of elements
elements.init()
// Init api service configs
ShopApiServiceInit()
ApiServiceInit()

Vue.config.productionTip = false
new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')

initMobileTables()
